import { useCallback } from 'react'

import { useNavigate } from 'Pods/Shared/ContextBasedRouter'
import { STUDIO_PATH, buildGalleryImagePath } from 'Pods/ThreeDStudio/constants'
import useRequireLogin from 'Pods/ThreeDStudio/Hooks/useRequireLogin'
import { openFullImageEditor } from 'Pods/ThreeDStudio/Store/actions/ui'

// Opens a community image in the full image editor, like the library's Edit image: at its
// shareable /ai-image-generator/images/:slug?edit=true URL, where ImageDeepLink opens the
// editor. An image without a slug opens it in place on the Image Generator route, the only
// other route that renders it, flagging the navigation so the editor survives it. No runId
// either way: the run belongs to another user, so the editor's Delete must stay disabled.
function useImageEdit() {
  const navigate = useNavigate()
  const requireLogin = useRequireLogin('login')

  return useCallback((image) => {
    if (!image.assetId || !requireLogin()) return

    if (image.slug) {
      navigate(buildGalleryImagePath(image.slug, { edit: true }))
      return
    }

    openFullImageEditor({ image: { id: image.assetId, url: image.src, alt: image.title } })
    navigate(STUDIO_PATH.IMAGE_GENERATOR, { state: { keepImageEditor: true } })
  }, [navigate, requireLogin])
}

export default useImageEdit
